import { render, staticRenderFns } from "./PurchaseorderLogList.vue?vue&type=template&id=6cadb10e"
import script from "./PurchaseorderLogList.vue?vue&type=script&lang=js"
export * from "./PurchaseorderLogList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports